import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { NgxPowerBiService } from 'ngx-powerbi';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { timer } from 'rxjs';
import { TokenPBService } from 'src/app/servicios/token-pb.service';
import { firstValueFrom } from 'rxjs';
//import {SharedModule} from '../../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { MSAL_INSTANCE } from '@azure/msal-angular';
import { PublicClientApplication } from '@azure/msal-browser';

//agregado MSALInstanceFactory 
export function MSALInstanceFactory() {
  return new PublicClientApplication({
    auth: {
      clientId: 'TU-CLIENT-ID',
      redirectUri: '/',
      authority: 'https://login.microsoftonline.com/common'
    }
  });
}

@Component({
    selector: 'app-power-bi',
    templateUrl: './power-bi.component.html',
    styleUrls: ['./power-bi.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, 
      DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, 
      AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule,
       NbSelectModule, NbTreeGridModule,
       SpinnerComponent, MultiSelectModule],
    providers: [
        {
          provide: MSAL_INSTANCE,
          useFactory: MSALInstanceFactory,
        },
        MsalService,
    ]
})
export class PowerBIComponent implements OnInit {
  private powerBiService: NgxPowerBiService;
  private pbiContainerElement: HTMLElement;
  permits = JSON.parse(localStorage.getItem('permits'));
  timer: Observable<any>;
  subscription: Subscription;
  showConsulta = false;
  showConsultaRepo = false;
  isIframe = false;
  loggedIn = false;
  isLoggedIn = false;
  showOpRepo = false;
  showLista = false;
  showLoading = true;
  pbaToken: string;
  pbaTokenTrunk: string;
  grupos: any = [];
  reportes: Array<any> = [];
  groupSelected;
  reportSelected;
  textRepo: string;

  loading: boolean = true;
  report: any = null;

  intentos: number =0;

  constructor(
    private tkPBService: TokenPBService, private authService: MsalService, private http: HttpClient) {
    this.powerBiService = new NgxPowerBiService();
    this.intentos = 0;
  }

  rep;

   //Llama a SetToken() para obtener y guardar el token de Power BI.
   //Inicia un timer de 1 segundo para cargar permisos, obtener el contenedor de Power BI y llamar a getGroups().
  ngOnInit(): void {
    this.SetToken()
    this.timer = timer(1000);
    this.subscription = this.timer.subscribe(() => {
      this.permits = JSON.parse(localStorage.getItem('permits'));
      this.pbiContainerElement = <HTMLElement>(document.getElementById('pbi-container'));
      this.getGroups();
    })
  }

  // updateToken:
  // decodifica el token y 
  // lo guarda en la variable de clase.

  updateToken(){
    this.tkPBService.getToken().subscribe(token => {
      this.pbaTokenTrunk = token
      var decodedData = window.atob(this.pbaTokenTrunk); // decode the string
      this.pbaToken = decodedData;
    });
  }

  // SetToken:
  // revisa si hay un token en localStorage:
  // Si no hay, lo solicita y lo guarda codificado en base64.
  // Si hay, lo usa directamente.
  SetToken() {
    let data = localStorage.getItem('tk_vca');
    if (data === null) {
       this.getToken().subscribe(data => {
        let token = data.access_token;
        let str = token;
        var encodedData = window.btoa(token);
        let k1 = 'tk_vca';
        let v1 = encodedData;
        this.tkPBService.setToken(encodedData)
        localStorage.setItem(k1, v1);
      });
    } else {
      this.tkPBService.setToken(data)
    }
    this.updateToken();
  }

  // getToken:
  // Hace una petición HTTP POST para obtener un token 
  // de Power BI usando credenciales (grant_type password).
  getToken(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': '*/*',
        'Access-Control-Allow-Origin': '*',
        'origin': 'x-requested-with',
      })
    };

    const body = new HttpParams()
      .set('client_id', 'cfae06ec-5a5b-4cac-a716-f99be478168c')
      .set('scope', 'https://analysis.windows.net/powerbi/api/Group.Read.All')
      .set('username', 'soporte@vca.com.ar')
      .set('password', 'Vca.2021')
      .set('grant_type', 'password')

  return this.http.post<XMLHttpRequest>('https://cors-proxy-server-vca.herokuapp.com/https://login.microsoftonline.com/8737cc12-c872-4583-ab1e-a3ea807e32fa/oauth2/v2.0/token', body.toString(), httpOptions)

  }

  actualizarLista() {
    this.permits = JSON.parse(localStorage.getItem('permits'));
    this.showLoading = true;
    this.adToken(true);
  }

  getPermitionsReports(reporte) {
    let permiso: Array<any> = [];
    for (const i in this.permits) {
      if (this.permits[i].Modulo === reporte) {
        return true;
      }
    }
  }

  adToken(consulta?) {
    if (consulta === true) {
      this.reportes = [];
    }
    const requestObj = {
      scopes: ["https://analysis.windows.net/powerbi/api/Group.Read.All"]
    };

    // this.authService.acquireTokenSilent(requestObj).then(tokenResponse => {
    //   this.pbaToken = tokenResponse.accessToken;
    //   this.getGroups();

      firstValueFrom(this.authService.acquireTokenSilent(requestObj))
        .then(tokenResponse => {
          this.pbaToken = tokenResponse.accessToken;
          this.getGroups();
 
    }).catch(function (error) {
    });
  }

  getGroups() {
    this.getGroupsbyToken().subscribe(grupos => {
      let gruposReponse: any = [];
      gruposReponse = grupos;
      gruposReponse.value.forEach(element => {
        this.getReports(element.id);
      });
      this.showLista = true;
      this.showLoading = false;

      this.timer = timer(9000);
      this.subscription = this.timer.subscribe(() => {
        if (this.reportes.length === 0) {
          this.textRepo = 'No hay reportes relacionados a su perfil';
          this.showLista = false;
          this.showLoading = false;
        } else {
          this.textRepo = '';
          this.showLista = true;
        }
      });
    },
      error => {
        this.removeToken();
        this.SetToken();
        if (this.intentos <3)
        {
          var refresh  = timer(5000);
          this.subscription = refresh.subscribe(() => {
            this.getGroups();
            this.intentos++;

          });        
        }
      });
  }

  removeToken() {
      localStorage.removeItem("tk_vca");
  }

  // Hace una petición HTTP GET a la API de Power BI 
  // para obtener los grupos, usando el token.
  getGroupsbyToken() {
    const header = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.pbaToken
    })
    return this.http.get('https://api.powerbi.com/v1.0/myorg/groups/', { headers: header })
  }


  // Por cada grupo, obtiene los reportes disponibles 
  // y los agrega a la lista de reportes.
  getReports(groupId) {
    this.getReportsInGroup(groupId).subscribe(reportes => {
      let reportesReponse: any = [];
      let aprobadoInsert = false;
      reportesReponse = reportes;
      reportesReponse.value.forEach(element => {
        //aprobadoInsert = this.getPermitionsReports(element.name);
        this.reportes.push({ id: element.id, name: element.name, idGroup: groupId })
        /* if (aprobadoInsert === true) {
        } */
      });
      this.loading = false
    });
  }


  getReportsInGroup(groupId: string) {
    const header = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.pbaToken
    })
    return this.http.get('https://api.powerbi.com/v1.0/myorg/groups/' + groupId + '/reports', { headers: header })
  }

  // Cuando el usuario selecciona un reporte, 
  // lo embebe en el contenedor usando el servicio 
  // de Power BI y el token.
  reportChange(e) {
    this.showConsulta = true;
    this.reportSelected = e.id;
    this.groupSelected = e.idGroup;
    this.consultar();
  }

  consultar() {
    this.showConsultaRepo = true;
    let config = {
      type: 'report',
      id: this.reportSelected,
      tokenType: 0,
      embedUrl:
        'https://app.powerbi.com/reportEmbed?' +
        'reportId=' + this.reportSelected +
        '&groupId=' + this.groupSelected,
      accessToken: this.pbaToken,
      settings: {
        filterPaneEnabled: true,
        navContentPaneEnabled: true
      }
    };
    this.report = this.powerBiService.embed(this.pbiContainerElement, config);
  }

  // Recarga el reporte
  reload() {
    if (this.report) {
      this.report.reload()
    }
  }
  // Reporte en pantalla completa
  fullScreen() {
    if (this.report) {
      this.report.fullscreen()
    }
  }
}

